import { isTextEntryTarget } from '@lib/keyboard/shortcuts';
import { useEffect } from 'react';

interface UseKeyboardEventsParams {
  scrubToWithKeyboardBounds: (time: number) => void;
  togglePlayPause: () => void;
  showSkipFeedbackTemporarily: (direction: 'forward' | 'backward') => void;
  currentTime: number;
}

export const useKeyboardEvents = ({
  scrubToWithKeyboardBounds,
  togglePlayPause,
  showSkipFeedbackTemporarily,
  currentTime,
}: UseKeyboardEventsParams) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isTextEntryTarget(e.target)) return;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          e.stopPropagation();
          scrubToWithKeyboardBounds(currentTime - 5);
          showSkipFeedbackTemporarily('backward');
          break;
        case 'ArrowRight':
          e.preventDefault();
          e.stopPropagation();
          scrubToWithKeyboardBounds(currentTime + 5);
          showSkipFeedbackTemporarily('forward');
          break;
        case ' ':
          e.stopPropagation();
          e.preventDefault();
          togglePlayPause();
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [scrubToWithKeyboardBounds, togglePlayPause, showSkipFeedbackTemporarily, currentTime]);
};
